export class CredentialData {
  static FIELD_TYPES = {
    STRING: 'string',
    INTEGER: 'integer',
    BOOLEAN: 'boolean',
    FLOAT: 'float'
  };

  constructor(data) {
    this.tool_name = data.tool_name;
    this.fields = this.normalizeFields(data.fields || {});
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.encrypted_data = data.encrypted_data;
  }

  normalizeFields(fields) {
    // Ensure fields match the expected structure
    return Object.entries(fields).reduce((acc, [key, value]) => {
      acc[key] = {
        value: value.value,
        field_type: value.field_type || CredentialData.FIELD_TYPES.STRING,
        secure: value.secure === 'true' || value.secure === true
      };
      return acc;
    }, {});
  }

  static fromApiResponse(data) {
    // console.log('Creating CredentialData from:', data); // Debug log
    return new CredentialData({
      tool_name: data.tool_name,
      fields: data.fields,
      created_at: data.created_at,
      updated_at: data.updated_at,
      encrypted_data: data.encrypted_data
    });
  }

  static fromApiResponseList(dataList = []) {
    // console.log('Creating CredentialData list from:', dataList); // Debug log
    return dataList.map(CredentialData.fromApiResponse);
  }

  toApiFormat() {
    return {
      tool_name: this.tool_name,
      fields: this.fields
    };
  }

  getFieldType(fieldName) {
    return this.fields[fieldName]?.field_type || CredentialData.FIELD_TYPES.STRING;
  }

  isSecureField(fieldName) {
    return this.fields[fieldName]?.secure || false;
  }

  getFieldValue(fieldName) {
    return this.fields[fieldName]?.value;
  }
}